// Generated types for StatementsSummaryTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { StepTaskReadAPI, StepTaskWriteAPI } from '../../llm_task/types/steptask';
import { StepTaskReadAPISchemaObject, StepTaskWriteAPISchemaObject } from '../../llm_task/types/steptask';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface StatementsSummaryTaskReadAPI extends StepTaskReadAPI {
}

export interface StatementsSummaryTaskWriteAPI extends StepTaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const StatementsSummaryTaskReadAPISchema: z.ZodType<StatementsSummaryTaskReadAPI> = StepTaskReadAPISchemaObject.extend({}).passthrough();

export const StatementsSummaryTaskWriteAPISchema: z.ZodType<StatementsSummaryTaskWriteAPI> = StepTaskWriteAPISchemaObject.extend({}).passthrough();
